<template>
  <div class="grid-row"
       :class="[type, {'active': value.id === object.id}]"
  >
    <div class="grid-col-1 grid-col">
      <span>{{ translate(object.title) }}</span>
    </div>

<!--    <div class="grid-col-2 grid-col">-->
<!--      -->
<!--    </div>-->

    <div class="grid-col-3 grid-col">
      <span
          v-text="object.measurement_dn"
      ></span>
    </div>

    <div class="grid-col-4 grid-col">
      <span
          v-text="object.measurement_outer"
      ></span>
    </div>

    <div class="grid-col-5 grid-col">
      <span
          v-text="preferences.unit === 'psi' ? object.pressure * PSI : object.pressure"
      ></span>
    </div>

    <div class="grid-col-6 grid-col">
      <span
          v-text="preferences.unit === 'psi' ? object.burst_pressure * PSI : object.burst_pressure "
      ></span>
    </div>

    <div class="grid-col-7 grid-col">
      <span
          v-text="object.bend_radius"
      ></span>
    </div>

    <div class="grid-col-8 grid-col">
      <span
          v-text="object.kg_m"
      ></span>
    </div>

    <div class="grid-col-9 grid-col">
          <button type="button"
                  @click="change(object)"
          >
            <span v-if="value.id === object.id">
              {{ $t('hose.selected') }}
            </span>
            <span v-else>
              {{ $t('hose.select') }}
            </span>
          </button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "GridRowHoses",

  props: {
    object: {
      type: Object,
    },
    type: {
      type: String,
      default: 'hose',
    },
    value: {
      type: Object,
    }
  },

  computed: {
    ...mapGetters({
      preferences: "build/hoses/getHosePreferences",
      PSI: 'build/hoses/getPSI'
    }),
  },

  methods: {
    change(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    }
  },
}
</script>

<style scoped lang="scss">
.grid-row {
  display: grid;
  grid-template-columns: repeat(8, 2fr) 3fr;
  background-color: #F5F5F5;
  font-size: 12px;
  align-content: center;
  align-items: center !important;

  &.hose {
    max-height: 36px;
    padding: 7px 0;
    font-family: neue-haas-grotesk-text, sans-serif;

    &.active {
      background-color: rgba(61, 176, 199, 0.25);

      .grid-col {
        button {
          background-color: #71BC29;
        }
      }
    }

    &:nth-child(odd) {
      background-color: #EBEBEB;

      &.active {
        background-color: rgba(61, 176, 199, 0.25);
      }
    }
  }

  .grid-col {
    display: flex;
    justify-content: center;
    border-left: 3px solid #F0F0F0;

    &:first-child {
      border-left: none;
    }

    button {
      background-color: #3DB0C7;
      color: white;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-size: 11px;
      border-radius: 25px;
      max-width: 130px;
      width: 100%;
      border: none;
      outline: none;
      box-shadow: none;
      padding: 4px 0;
      transition: all ease 0.3s;

      &:hover {
        background-color: darken(#3DB0C7, 20%);
      }
    }
  }
}
</style>